<template>
  <b-modal
    :visible="!!payload"
    :title="title"
    size="md"
    centered
    hide-footer
    @hide="$emit('close')"
  >
    <div v-if="payload">
      <div
        v-if="violations.length"
        class="rule-pendencies"
      >
        <ul class="rule-pendencies-list">
          <li
            v-for="(v, i) in violations"
            :key="`e${i}`"
          >
            <b-form-checkbox
              v-if="canOverride && v.allows_override"
              :checked="overrideIds.includes(v.rule_id)"
              class="d-inline-block mr-50"
              @change="toggleOverride(v.rule_id)"
            />
            {{ v.message }}
            <button
              v-if="canOpen(v)"
              type="button"
              class="btn btn-link btn-sm p-0 ml-50 align-baseline"
              @click="$emit('open', v)"
            >
              Resolver
            </button>
          </li>
        </ul>

        <div
          v-if="canOverride && hasOverridable"
          class="mt-1"
        >
          <small class="text-muted d-block mb-25">
            Marque a pendência que deseja dispensar e justifique — a dispensa fica registrada.
          </small>
          <textarea
            v-model="overrideReason"
            class="form-control"
            rows="2"
            placeholder="Justificativa da dispensa..."
            maxlength="1000"
          />
        </div>
      </div>

      <div
        v-if="warnings.length"
        class="rule-warnings"
      >
        <div class="rule-block-title">
          <feather-icon
            icon="AlertCircleIcon"
            size="15"
            class="mr-50"
          />
          Avisos
        </div>
        <ul class="rule-pendencies-list">
          <li
            v-for="(w, i) in warnings"
            :key="`w${i}`"
          >
            {{ w.message }}
          </li>
        </ul>
      </div>

      <div
        class="d-flex justify-content-end mt-1"
        style="gap: 8px"
      >
        <button
          type="button"
          class="btn btn-outline-secondary"
          @click="$emit('close')"
        >
          Voltar
        </button>
        <button
          v-if="canProceed"
          type="button"
          class="btn btn-danger"
          :disabled="retrying"
          @click="retry"
        >
          <b-spinner
            v-if="retrying"
            small
            class="mr-50"
          />
          {{ requiresConfirmation ? 'Confirmar mesmo assim' : 'Dispensar e continuar' }}
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BFormCheckbox, BSpinner } from 'bootstrap-vue'

export default {
  name: 'BusinessRulePendenciesModal',
  components: { BModal, BFormCheckbox, BSpinner },

  props: {
    payload: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: 'Não é possível concluir esta ação',
    },
    retrying: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      overrideIds: [],
      overrideReason: '',
    }
  },

  computed: {
    violations() {
      return (this.payload && this.payload.errors) || []
    },

    warnings() {
      return (this.payload && this.payload.warnings) || []
    },

    requiresConfirmation() {
      return !!(this.payload && this.payload.requires_confirmation)
    },

    canOverride() {
      return this.$hasAbility('regra.dispensar')
    },

    hasOverridable() {
      return this.violations.some(v => v.allows_override)
    },

    canProceed() {
      if (this.requiresConfirmation) return true
      return this.canOverride && this.overrideIds.length > 0 && !!this.overrideReason.trim()
    },
  },

  watch: {
    payload() {
      this.overrideIds = []
      this.overrideReason = ''
    },
  },

  methods: {
    canOpen(violation) {
      return !!(violation.occurrence_involved_id && violation.target)
    },

    toggleOverride(ruleId) {
      const i = this.overrideIds.indexOf(ruleId)
      if (i >= 0) this.overrideIds.splice(i, 1)
      else this.overrideIds.push(ruleId)
    },

    retry() {
      this.$emit('retry', {
        confirm_warnings: this.requiresConfirmation,
        override_rule_ids: this.overrideIds,
        override_reason: this.overrideReason || null,
      })
    },
  },
}
</script>

<style scoped>
.rule-pendencies {
  background: #fdeaea;
  border-left: 3px solid #ea5455;
  border-radius: 6px;
  padding: 10px 14px;
  margin-bottom: 12px;
}
.dark-layout .rule-pendencies {
  background: #2c1a1b;
}
.rule-warnings {
  background: #fff8e6;
  border-left: 3px solid #ff9f43;
  border-radius: 6px;
  padding: 10px 14px;
  margin-bottom: 12px;
}
.dark-layout .rule-warnings {
  background: #2e2214;
}
.rule-block-title {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 0.87rem;
  margin-bottom: 6px;
}
.rule-pendencies-list {
  margin: 0;
  padding-left: 18px;
  font-size: 0.85rem;
  line-height: 1.6;
}
</style>
